class Option {
  constructor (text, value) {
    this.text = text
    this.value = value// !value ? text : value
  }
}
export default Option



// WEBPACK FOOTER //
// ./src/lib/transfer-objects/Option.js